export const UPDATE_SEARCH_PARAMS_FROM_URL = "UPDATE_SEARCH_PARAMS_FROM_URL";
export const SEARCH_START = "SEARCH_START";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const CONTENT_SEARCH_SUCCESS = "CONTENT_SEARCH_SUCCESS";
export const SEARCH_FAILURE = "SEARCH_FAILURE";

export const CHANGE_SORT = "CHANGE_SORT";
export const CHANGE_SORT_DIRECTION = "CHANGE_SORT_DIRECTION";
export const CHANGE_PAGE = "SRP: Change product results page";
export const CHANGE_CONTENT_PAGE = "SRP: Change content results page";
export const TOGGLE_FACET = "TOGGLE_FACET";
export const REMOVE_BREADCRUMB = "REMOVE_BREADCRUMB";

export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
export const CLEAR_ALL = "CLEAR_ALL";
export const APPLY_ALL = "APPLY_ALL";
export const CLEAR_TECH_VALUES = "CLEAR_TECH_VALUES";

export const SELECT_PRODUCT_GROUP = "SELECT_PRODUCT_GROUP";
export const SELECT_PRODUCT_GROUP_MULTI = "SELECT_PRODUCT_GROUP_MULTI";
export const SET_SELECTED_PRODUCT_GROUPS = "SET_SELECTED_PRODUCT_GROUPS";

export const UPDATE_ASSISTANT_VALUES = "UPDATE_ASSISTANT_VALUES";
export const UPDATE_IS_SELECTION_ASSISTANT = "UPDATE_IS_SELECTION_ASSISTANT";

export const UPDATE_CAMPAIGN_FILTER = "UPDATE_CAMPAIGN_FILTER";
export const UPDATE_RELEVANT_FILTER = "UPDATE_RELEVANT_FILTER";
export const SET_SHOW_RELEVANT_TOGGLE = "SET_SHOW_RELEVANT_TOGGLE";

export const SRP_FETCH_RECOMMENDED_PRODUCTS_START = "SRP_FETCH_RECOMMENDED_PRODUCTS_START";
export const SRP_FETCH_RECOMMENDED_PRODUCTS_SUCCESS = "SRP_FETCH_RECOMMENDED_PRODUCTS_SUCCESS";
export const SRP_FETCH_RECOMMENDED_PRODUCTS_FAILURE = "SRP_FETCH_RECOMMENDED_PRODUCTS_FAILURE";
export const SET_RECOMMENDATION_PLACEMENT = createAction<RecommendationPlacement | undefined>(
  "SET_RECOMMENDATION_PLACEMENT",
);

export const UPDATE_COLUMN_VISIBILITY = "UPDATE_COLUMN_VISIBILITY";
import { createAction } from "@reduxjs/toolkit";
import type { RecommendationPlacement } from "~/features/search/models/RecommendationPlacement";
